<template>
	<!-- CTA -->
	<div class='cta'>

		<!-- background -->
		<div class='cta__background sticky flex'>

			<div class='cta__icon-bridge has-filter-dark-blue' />
			<div class='cta__icon-water has-filter-white' />
		</div>

		<!-- foreground -->
		<div class='cta__foreground flex'>
			<div class='cta__content' />
			<div class='cta__content flex'>

				<!-- video -->
				<div class='card'>
					<div class='card__content'>
						<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/481262415?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>
					</div>
				</div>

				<!-- donate -->
				<div class='card card-cta'>
					<div class='card__content '>
						<p class='card__text card__text-cta'>
							<span v-if="lang === 'en'">Help us end poverty caused by rural isolation and build pathways to resilience.</span>
							<span v-else>Ayúdanos a terminar con la pobreza causada por el aislamiento rural y a construir caminos hacia la resiliencia.</span>
						</p>
						<!-- <p><a href='https://bridgestoprosperity.org/'>
							<span v-if="lang === 'en'">visit us</span>
							<span v-else>visítanos</span>
						</a></p> -->
						<p><a href='https://donate.bridgestoprosperity.org/campaign/one-bridge-a-global-solution/c306323'>
							<span v-if="lang === 'en'">Donate today</span>
							<span v-else>Dona hoy</span>
						</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>



<script>
	export default {
		props: {
			lang: String
		}
	}
</script>